# Read the cookies and returns a dictionary object
read = ->
  cookie_details = document.cookie.split(';').map (c) ->
    c       = c.trim()
    details = c.split /\=/
    name: details[0], value: decodeURIComponent(details[1])
  
  cookies = {}
  for { name, value } in cookie_details when name.match /^webed/
    cookies[name.replace("webed_", "")] = value
  cookies

module.exports = {
  read
}
